/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

module.exports =
  require('../core/Pair')



//////////////////
// WEBPACK FOOTER
// ./~/crocks/Pair/index.js
// module id = ./node_modules/crocks/Pair/index.js
// module chunks = 0